import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Fab from '@material-ui/core/Fab';
import CloseIcon from '@material-ui/icons/Close';
import { Typography } from '@material-ui/core';
import styles from './styles';

class PopupTimeline extends React.Component {
  render() {
    const { timelinePopupData, color, classes, open, onClose } = this.props;
    const title = parse(timelinePopupData.title);
    const desc = parse(timelinePopupData.desc);
    const colorClass = color !== undefined ? color : 'purple';
    return (
      <Dialog
        maxWidth="md"
        fullWidth
        scroll="body"
        open={open || false}
        onClose={onClose}
        PaperProps={{
          square: true,
          className: `${classes.dialogPaper} ${classes[colorClass]}`,
        }}
      >
        <Fab color="primary" onClick={onClose} className={classes.closeIcon}>
          <CloseIcon fontSize="large" />
        </Fab>
        <DialogTitle disableTypography>
          <Typography variant="h3">{title}</Typography>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Typography variant="body1">{desc}</Typography>
        </DialogContent>
      </Dialog>
    );
  }
}

PopupTimeline.propTypes = {
  timelinePopupData: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  title: PropTypes.node,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  color: PropTypes.oneOf(['purple', 'blue', 'green', 'yellow', 'red']),
};

export default withStyles(styles)(PopupTimeline);
